import React, { useState } from "react";
import PageTitle from "../Common/PageTitle";
import MyCustomSelect, {
  formatOptionLabel,
} from "../../common/elements/myCustomSelect";
// import { TuckInCall } from "./TuckInCall";
import MyBackdropSpinner from "../../common/elements/myBackdropSpinner";
// import { ChangeinConditionNote } from "./ChangeinConditionNote";
// import { TherapyUtilizationReview } from "./TherapyUtilizationReview";
// import { IPHospitalCommNote } from "./IPHospitalCommNote";
// import CceTracking from "./CceTracking";
// import AdmReAdm from "./AdmReAdm";
// import HighRisk from "./HighRisk";
// import { Notes } from "./Notes";
import useSWR from "swr";
import { fetcher } from "../../services/fectcher";
// import TriageCall from "./TriageCall";
import { usePickList } from "../../services/queries";
import { Checkbox } from "antd";

export const CareEventFormsMSSP = () => {
  const [activePar, setActivePar] = useState(true);

  // const { data: allPatients, isLoading } = useSWR(
  //   `GetPatientsListNew?lob=${"HN,PAC"}&refresh=true&activeProviderGroup=${activePar}`,
  //   fetcher
  // );

  const formOptions = usePickList(35).data;

  const [selecdtedPatient, setSelecdtedPatient] = useState();
  const [selecdtedEvent, setSelecdtedEvent] = useState();

  const [checked, setChecked] = useState(false);

  const onChange = (e) => {
    console.log("checked = ", e.target.checked);
    setActivePar(!activePar);
    setChecked(e.target.checked);
  };

  return (
    <>
      <PageTitle title={"Care Event - MSSP"} />
      {/* {isLoading && <MyBackdropSpinner show={isLoading} />} */}
      {/* <div className="tw-flex tw-place-content-start tw-gap-4">
        <div className="tw-basis-2/5">
          <div className="tw-flex tw-items-center tw-justify-between">
            <label htmlFor="patientName" className=" fw-bold">
              Patient
            </label>
            <Checkbox checked={checked} onChange={onChange}>
              Show All Patients of Non - Active Group
            </Checkbox>
          </div>

          <MyCustomSelect
            selectOptions={allPatients}
            selectedValue={selecdtedPatient}
            myCallBack={(e) => {
              setSelecdtedPatient(e);
              setSelecdtedEvent("");
            }}
            formatOptionLabel={formatOptionLabel}
          />
        </div>
        <div className="tw-basis-1/3">
          <label htmlFor="eventType" className=" fw-bold">
            Care Event Forms
          </label>
          <MyCustomSelect
            selectOptions={formOptions}
            selectedValue={selecdtedEvent}
            disable={selecdtedPatient?.value ? false : true}
            myCallBack={(e) => setSelecdtedEvent(e)}
            // errorMessage={pageError?.patientId}
          />
        </div>
      </div> */}
      
    </>
  );
};
